(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wt-announcement-marquee')) {
    customElements.define('wt-announcement-marquee', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.wt-marquee__viewport');
        this.track = this.querySelector('.wt-marquee__track');
        this.group = this.querySelector('[data-original]');
        this.button = this.querySelector('.wt-marquee__toggle');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.selected = false;
        this.group.querySelectorAll('.announcement-bar__slide').forEach(slide => slide.removeAttribute('aria-hidden'));
        this.button.addEventListener('click', () => { this.paused = !this.paused; this.updatePlayback(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.updatePlayback(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.updatePlayback(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.updatePlayback(); }, options);
        this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.updatePlayback(); }); }, options);
        document.addEventListener('shopify:block:select', event => { if (this.contains(event.target)) { this.selected = true; this.updatePlayback(); } }, options);
        document.addEventListener('shopify:block:deselect', event => { if (this.contains(event.target)) { this.selected = false; this.updatePlayback(); } }, options);
        this.reduced.addEventListener('change', () => this.build(), options);
        this.observer = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (width !== this.lastWidth) { this.lastWidth = width; this.build(); }
        });
        this.observer.observe(this.viewport);
        this.build();
        document.fonts.ready.then(() => { if (this.isConnected) this.build(); });
      }
      duplicate(node) {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.dataset.repeat = '';
        [clone, ...clone.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          element.removeAttribute('ref');
        });
        return clone;
      }
      build() {
        this.animation?.cancel();
        this.track.querySelectorAll('[data-repeat]').forEach(node => node.remove());
        this.viewport.scrollLeft = 0;
        if (this.reduced.matches) return;
        const children = [...this.group.children];
        if (!children.length) return;
        let width = this.group.getBoundingClientRect().width;
        if (width < 1) return;
        let repeats = 0;
        while (width < this.viewport.clientWidth && repeats < 30) {
          children.forEach(child => this.group.append(this.duplicate(child)));
          width = this.group.getBoundingClientRect().width;
          repeats++;
        }
        this.track.append(this.duplicate(this.group));
        const speed = Number(this.dataset.speed) || 40;
        this.animation = this.track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }], { duration: width / speed * 1000, iterations: Infinity, easing: 'linear' });
        this.updatePlayback();
      }
      updatePlayback() {
        if (!this.isConnected) return;
        const pause = this.paused || this.hovered || this.focused || this.selected;
        if (pause) this.animation?.pause(); else this.animation?.play();
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.button.dataset.resume : this.button.dataset.pause);
        this.button.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      disconnectedCallback() {
        this.animation?.cancel();
        this.observer?.disconnect();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
